import {
  OPTIONS_FETCH_REQUEST,
  OPTIONS_FETCH_REQUEST_SUCCESS,
  OPTIONS_FETCH_REQUEST_FAILURE,
  OPTIONS_CLEAN_REQUEST,
} from './actionTypes';

export const optionsFetchRequest = () => {
  return {
    type: OPTIONS_FETCH_REQUEST,
  };
};

export const optionsFetchRequestSuccess = (data, optionName) => {
  return {
    type: OPTIONS_FETCH_REQUEST_SUCCESS,
    data,
    optionName,
  };
};

export const optionsFetchRequestFailure = (error) => {
  return {
    type: OPTIONS_FETCH_REQUEST_FAILURE,
    error,
  };
};

export const optionsCleanRequest = () => {
  return {
    type: OPTIONS_CLEAN_REQUEST,
  };
};
